import { render, staticRenderFns } from "./Callback-signin-oidc.vue?vue&type=template&id=2ea15364"
import script from "./Callback-signin-oidc.vue?vue&type=script&lang=js"
export * from "./Callback-signin-oidc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports